import React, { Component } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import defaultLoader from '../home/images/loader.gif';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@mui/styles';

const styles = theme => ({
    diagnostics_dialogbox: {
        '& .MuiPaper-root': {
            maxWidth: '100% !important',
            width: '100% !important',
            height: '100% !important',
            '& .container': {
                width: 'inherit',
                height: 'inherit',
                '& iframe': {
                    width: 'inherit',
                    height: 'inherit',
                },
            },
        },
        '& .MuiDialogTitle-root': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    },
})

class TestConsultationPopup extends Component {
    handleTestConsultationPopupClose = () => {
        this.props.handleShowTestConsultation(false);
        this.props.handleCloseTestConsultationPopupLoader();
    }

    render() {
        const { t, classes, openTestConsultationPopup, loader, handleCloseTestConsultationPopupLoader } = this.props;

        const lang = localStorage.getItem('i18nextLng') || 'en';

        return (
            <Dialog
                open={openTestConsultationPopup}
                onClose={this.handleTestConsultationPopupClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={classes.diagnostics_dialogbox}
            >
                <DialogTitle>
                    <span>{t("Home.ConsultDiagnosisPopup.ConsultDiagnosisTitle")}</span>
                    <IconButton onClick={this.handleTestConsultationPopupClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="container">
                    <iframe
                        title="Consult Diagnostics - iLocalBox"
                        src={`${process.env.REACT_APP_CONSULT_DIAGNOSTICS_APP_URL}${lang}`}
                        frameBorder="0"
                        allow="camera; microphone"
                        onLoad={handleCloseTestConsultationPopupLoader}
                        style={{ width: "100%", height: "500px", border: "none" }}
                    />
                </DialogContent>

                {loader && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "rgba(255,255,255,0.3)",
                            zIndex: "999999",
                        }}
                    >
                        <img
                            src={defaultLoader}
                            alt="Processing"
                            style={{
                                position: "absolute",
                                top: "50%",
                                width: "100px",
                                zIndex: "999999999",
                            }}
                        />
                    </div>
                )}
            </Dialog>
        );
    }
}

export default withStyles(styles, { withTheme: true })(withTranslation()(TestConsultationPopup));



// WEBPACK FOOTER //
// ./src/components/common/TestConsultationPopup.js